import React, { useState, useRef } from 'react';
import SearchIcon from '../../components/svg/Search';
import styled, { css } from 'styled-components/macro';
import matchSorter from 'match-sorter';

const FiltroPartidos = ({ partidos, setPartidos, nomenclator, setFiltered, filtered }) => {
  const setFilter = text => {
    let newArray = JSON.parse(JSON.stringify(partidos));
    newArray.map((camara, i) => {
      if (camara.partotabla.length > 0) {
        newArray[i].partotabla = matchSorter(camara.partotabla.filter(x => x.act.carg > 0), text, {
            keys: [
              item => {
                return nomenclator.partidos[Number(item.act.codpar) - 1].nombre;
              },
            ],
            threshold: matchSorter.rankings.CONTAINS
          })
        ;
      }
    });
    setFiltered(!filtered);
    setPartidos(newArray);
  };
  return (
    <div
      css={`
        display: flex;
        margin-bottom: 1rem;
      `}
    >
      <Input
        placeholder={'filtrado de partidos...'}
        onChange={e => {
          setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
        }}
      />
      <SearchIconWrapper>
        <SearchIcon fill={'#283F5F'} />
      </SearchIconWrapper>
    </div>
  );
};

export default FiltroPartidos;

const SearchIconWrapper = styled.div`
  background-color: transparent;
  border: none;
  right: 10px;
  top: 0;
  width: 47px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 2rem;
  /*IE11: Column flex items set to align-items: center overflow their container https://github.com/philipwalton/flexbugs#flexbug-2 */
  max-width: 47px;
`;

const Input = styled.input`
  position: relative;
  box-sizing: border-box;
  border: none;
  font-size: 14px;
  background-color: transparent;
  // transition: background-color 0.3s ease 0s;
  border-bottom: 1px solid #bbb;
  ::placeholder {
    font-style: italic;
    opacity: 0.9;
  }
`;
